import { Col, Row } from 'antd';
import React, { useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import VoucherAmountPicker from '../../components/voucher-amount-picker/voucher-amount-picker';
import { IGiftVoucherConfig } from '../../interfaces/IGiftVoucherConfig';
import { IApplicationState } from '../../store';
import { actionCreators as GiftVoucherActions } from '../../store/GiftVoucher';

export interface IVoucherAmountFixedProps {
    voucherConfig?: IGiftVoucherConfig | undefined;
    isGlobal: boolean;
}

const VoucherAmountFixed: React.FunctionComponent<IVoucherAmountFixedProps> = (props) => {
    const { voucherConfig, isGlobal } = props;

    const dispatch = useDispatch();
    const selectedGiftVoucherButtonIndex = useSelector((state: IApplicationState) => state.giftVoucher.selectedFixedAmountButtonIndex);
    const selectedVoucherCurrency = useSelector((state: IApplicationState) => state.giftVoucher.selectedVoucherCurrency);
    const siteCurrencySymbol = useSelector((state: IApplicationState) => state.sites.selectedSite?.currencySymbol);
    const discountPercentage = useSelector((state: IApplicationState) => state.giftVoucher.configDetails?.activeDiscount?.discountPercentage);

    const currencySymbol = useMemo(() => {
        if (isGlobal) {
            //and the currency type matches up properly, use that symbol
            if (selectedVoucherCurrency && selectedVoucherCurrency.id === voucherConfig?.currencyTypeId) {
                return selectedVoucherCurrency.symbol ?? '?';
            }
        }
        else {
            //otherwise default back to the venues currency symbol and assume that matches the values we are displaying
            return siteCurrencySymbol ?? '?';
        }

        return '?';

    }, [voucherConfig, selectedVoucherCurrency, siteCurrencySymbol, isGlobal]);

    const amountSelected = useCallback(
        (voucherAmmount: number, buttonIndex: number) => {
            //console.log(`ammountSelected: voucherAmmount${voucherAmmount}, buttonIndex:${buttonIndex}`);
            dispatch(GiftVoucherActions.clearField);
            dispatch(GiftVoucherActions.buttonSelected(voucherAmmount, buttonIndex, isGlobal ?? false));
        },
        [dispatch, isGlobal]
    );

    //use the gift voucher ticket price config to auto generate the 8 steps of value we offer as pre-sets
    const voucherAmmounts = useMemo(() => {
        //console.log(`building voucherAmmounts list`);
        //console.log(voucherConfig);
        var defaultButtonCount = 8;

        if (voucherConfig) {
            if (voucherConfig.presetOptions && voucherConfig.presetOptions.length > 0) {
                const res: number[] = voucherConfig.presetOptions.map(x => x.voucherAmount );
                return res;
            }
            else {
                const res = Array.from({ length: defaultButtonCount }, (_, i) => voucherConfig.price * (i + 1));
                return res;
            }
        }
        return [];
    }, [voucherConfig]);

    

    return (
        <React.Fragment>
            <Row justify="start" align="top">
                <Col span={24}>
                    <VoucherAmountPicker
                        defaultSelected={selectedGiftVoucherButtonIndex}
                        voucherAmmounts={voucherAmmounts}
                        currencySymbol={currencySymbol}
                        onChange={amountSelected}
                        discountPercentage={discountPercentage}
                        showTicketLabels={!isGlobal}
                    />
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default VoucherAmountFixed;
